import CryptoJS from 'crypto-js';

const SECRET_KEY = 'n6tc_jUh!E4-7Kv^/3+wH<=sYJe47q2XFN%!axzx8F/6Y<jfNQ>ent';

const IV_LENGTH = 16; // Tamanho do vetor de inicialização para AES

function encrypt(data, date) {
  // Gera a chave combinando data e SECRET_KEY
  const secretKey = `${date}${SECRET_KEY}`.padEnd(32, ' ').slice(0, 32);

  // Deriva a chave usando SHA-256 (igual ao original)
  const key = CryptoJS.SHA256(secretKey);

  // Gera o IV aleatório
  const iv = CryptoJS.lib.WordArray.random(IV_LENGTH);

  // Configurações de criptografia
  const options = {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  };

  // Criptografa os dados
  const encrypted = CryptoJS.AES.encrypt(data, key, options);

  // Formato final: IV_HEX:CIPHERTEXT_HEX
  return `${iv.toString(CryptoJS.enc.Hex)}:${encrypted.ciphertext.toString(CryptoJS.enc.Hex)}`;
}

export { encrypt };
